/**
 * Reseller ID constants
 * These are used throughout the application to identify different reseller types
 */

// Default reseller ID for tenant creation
export const DEFAULT_RESELLER_ID = '123e4567-e89b-12d3-a456-426614174000'

// QSE Enterprise reseller ID for enterprise clients
export const QSE_ENTERPRISE_ID = '876e4567-e89b-12d3-a456-426614174001'

/**
 * Reseller ID type for type safety
 */
export type ResellerId = typeof DEFAULT_RESELLER_ID | typeof QSE_ENTERPRISE_ID

/**
 * Check if a reseller ID is the QSE Enterprise ID
 */
export const isQseEnterprise = (resellerId: string): boolean => {
  return resellerId === QSE_ENTERPRISE_ID
}

/**
 * Check if a reseller ID is the default reseller ID
 */
export const isDefaultReseller = (resellerId: string): boolean => {
  return resellerId === DEFAULT_RESELLER_ID
}
